import { Link } from 'react-router-dom';

const CTASection = () => {
  return (
    <section className="relative py-16 md:py-24 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20abstract%20gradient%20with%20soft%20light%20rays%20and%20cinematic%20atmosphere%2C%20dark%20theater%20vibe%20with%20golden%20highlights%2C%20artistic%20minimal%20style%2C%20dreamy%20elegant%20background&width=1800&height=600&seq=cta-bg-01&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover"
        loading="lazy"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-background-950/90 via-background-950/70 to-background-950/90"></div>

      <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-4xl font-heading text-background-50 mb-4">
          准备好开始
          <span className="text-primary-400">在线观看</span>
          了吗？
        </h2>
        <p className="text-sm md:text-base text-background-200/80 mb-8 max-w-xl mx-auto leading-relaxed">
          注册即可免费在线观看海量高清内容，超低延迟、超清画质，随时随地畅享精彩。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/about"
            className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 rounded-full text-base font-medium hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer hover:scale-105"
          >
            <i className="ri-user-add-line mr-2"></i>免费注册账号
          </Link>
          <Link
            to="/category/dianying"
            className="w-full sm:w-auto px-8 py-3.5 bg-background-50/10 backdrop-blur-sm border border-background-50/20 text-background-50 rounded-full text-base font-medium hover:bg-background-50/20 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-movie-2-line mr-2"></i>浏览内容库
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CTASection;